import type { PspWarningSettings } from '@/types';

export async function fetchPspWarningSettings(): Promise<PspWarningSettings> {
  const fallback: PspWarningSettings = {
    show_warning_quickpay: false,
    show_warning_epay: false,
    payment_system_warning: '',
  };

  try {
    const response = await fetch('/of2/json/settings', {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });
    const data = await response.json();
    return {
      show_warning_quickpay: Boolean(data.show_warning_quickpay),
      show_warning_epay: Boolean(data.show_warning_epay),
      payment_system_warning: data.payment_system_warning ?? '',
    };
    console.log("PSP settings", data);
    
  } catch (e) {
    console.error('Failed to fetch PSP warning settings:', e);
    return fallback;
  }
}
